/**
 * 図書館フィルタ (Calil 検索の絞り込み対象館) API サービス
 *
 * バックエンド /api/library-selections を叩く軽量ラッパー。
 * サーバ側は「丸ごと置換 (PUT)」で保存する。
 */

import { apiClient } from '@/api/client'

type LibrarySelectionsResponse = {
  library_ids: number[]
}

/** ログインユーザーの図書館フィルタ選択を取得 */
export const getLibrarySelections = async (): Promise<number[]> => {
  const res = await apiClient.get<LibrarySelectionsResponse>('/library-selections')
  return res.data.library_ids
}

/** 図書館フィルタ選択を丸ごと置換 */
export const putLibrarySelections = async (libraryIds: number[]): Promise<number[]> => {
  const res = await apiClient.put<LibrarySelectionsResponse>('/library-selections', {
    library_ids: libraryIds,
  })
  return res.data.library_ids
}
